import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { ReviewFundingRequestBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const reviewFundingRequest = createApiThunk<void, { id: string; body: ReviewFundingRequestBody }>(
  "fundingRequests/reviewFundingRequest",
  async ({ id, body }, { extra: { adminRepository } }) => {
    return adminRepository!.review(id, body);
  },
);

export const resetReviewFundingRequest = createAction("fundingRequests/resetReviewFundingRequest");
